import Grid from "@mui/material/Grid";
import FormField from "../../../../../components/FormField";
import MDBox from "../../../../../components/MDBox";
import React from "react";
import MDTypography from "../../../../../components/MDTypography";

function EditDoctorForm({ formData }) {
    const { formField, values, errors, touched } = formData;

    const {name, bank, bank_account, short_description, email, phone, address, specialty, badge, password, password_confirmation, account_name, account_email, rfc, business_name, business_email, business_address, business_phone} = formField;
    const {
        name: nameV,
        short_description: shortDescriptionV,
        email: emailV,
        phone: phoneV,
        address: addressV,
        specialty: specialtyV,
        badge: badgeV,
        bank: bankV,
        bank_account: bankAccountV,
        account_name: accountNameV,
        account_email: accountEmailV,
        business_name: businessNameV,
        business_email: businessEmailV,
        business_phone: businessPhoneV,
        business_address: businessAddressV,
        rfc: rfcV,
        password: passwordV,
        password_confirmation: passwordConfirmationV
    } = values;

    return (
        <MDBox>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={name.type}
                        label={name.label}
                        name={name.name}
                        value={nameV}
                        error={errors.name && touched.name}
                        success={nameV && nameV.length > 0 && !errors.name}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={specialty.type}
                        label={specialty.label}
                        name={specialty.name}
                        value={specialtyV}
                        error={errors.specialty && touched.specialty}
                        success={specialtyV && specialtyV.length > 0 && !errors.specialty}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={badge.type}
                        label={badge.label}
                        name={badge.name}
                        value={badgeV}
                        error={errors.badge && touched.badge}
                        success={badgeV && badgeV.length > 0 && !errors.badge}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={rfc.type}
                        label={rfc.label}
                        name={rfc.name}
                        value={rfcV}
                        error={errors.rfc && touched.rfc}
                        success={rfcV && rfcV.length > 0 && !errors.rfc}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={short_description.type}
                        label={short_description.label}
                        name={short_description.name}
                        value={shortDescriptionV}
                        error={errors.short_description && touched.short_description}
                        success={shortDescriptionV && shortDescriptionV.length > 0 && !errors.short_description}
                        {...short_description}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <MDTypography variant="h6">Información de acceso</MDTypography>
                    <MDTypography variant="body2">¿Con qué datos ingresará a la plataforma?</MDTypography>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={email.type}
                        label={email.label}
                        name={email.name}
                        value={emailV}
                        error={errors.email && touched.email}
                        success={emailV && emailV.length > 0 && !errors.email}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        type={password.type}
                        label={password.label}
                        name={password.name}
                        value={passwordV}
                        error={errors.password && touched.password}
                        success={passwordV?.length > 0 && !errors.password}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        type={password_confirmation.type}
                        label={password_confirmation.label}
                        name={password_confirmation.name}
                        value={passwordConfirmationV}
                        error={errors.password_confirmation && touched.password_confirmation}
                        success={passwordConfirmationV?.length > 0 && !errors.password_confirmation}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <MDTypography variant="h6">Información comercial</MDTypography>
                    <MDTypography variant="body2">¿Cómo lo encuentra el público?</MDTypography>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={business_name.type}
                        label={business_name.label}
                        name={business_name.name}
                        value={businessNameV}
                        error={errors.business_name && touched.business_name}
                        success={businessNameV && businessNameV.length > 0 && !errors.business_name}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={business_address.type}
                        label={business_address.label}
                        name={business_address.name}
                        value={businessAddressV}
                        error={errors.business_address && touched.business_address}
                        success={businessAddressV && businessAddressV.length > 0 && !errors.business_address}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        type={business_email.type}
                        label={business_email.label}
                        name={business_email.name}
                        value={businessEmailV}
                        error={errors.business_email && touched.business_email}
                        success={businessEmailV && businessEmailV.length > 0 && !errors.business_email}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        type={business_phone.type}
                        label={business_phone.label}
                        name={business_phone.name}
                        value={businessPhoneV}
                        error={errors.business_phone && touched.business_phone}
                        success={businessPhoneV && businessPhoneV.length > 0 && !errors.business_phone}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <MDTypography variant="h6">Información de contacto</MDTypography>
                    <MDTypography variant="body2">¿Cómo contactaremos al doctor?</MDTypography>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={phone.type}
                        label={phone.label}
                        name={phone.name}
                        value={phoneV}
                        error={errors.phone && touched.phone}
                        success={phoneV && phoneV.length > 0 && !errors.phone}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={address.type}
                        label={address.label}
                        name={address.name}
                        value={addressV}
                        error={errors.address && touched.address}
                        success={addressV && addressV.length > 0 && !errors.address}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <MDTypography variant="h6">Información bancaria</MDTypography>
                    <MDTypography variant="body2">¿A dónde se depositarán sus ganancias?</MDTypography>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={account_name.type}
                        label={account_name.label}
                        name={account_name.name}
                        value={accountNameV}
                        error={errors.account_name && touched.account_name}
                        success={accountNameV && accountNameV.length > 0 && !errors.account_name}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={bank.type}
                        label={bank.label}
                        name={bank.name}
                        value={bankV}
                        error={errors.bank && touched.bank}
                        success={bankV && bankV.length > 0 && !errors.bank}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={bank_account.type}
                        label={bank_account.label}
                        name={bank_account.name}
                        value={bankAccountV}
                        error={errors.bank_account && touched.bank_account}
                        success={bankAccountV && bankAccountV.length > 0 && !errors.bank_account}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={account_email.type}
                        label={account_email.label}
                        name={account_email.name}
                        value={accountEmailV}
                        error={errors.account_email && touched.account_email}
                        success={accountEmailV && accountEmailV.length > 0 && !errors.account_email}
                    />
                </Grid>
            </Grid>
        </MDBox>
    );
}

export default EditDoctorForm;
